import { render, staticRenderFns } from "./seriesdetail.vue?vue&type=template&id=fc21512a&scoped=true&"
import script from "./seriesdetail.vue?vue&type=script&lang=js&"
export * from "./seriesdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc21512a",
  null
  
)

export default component.exports